import { render, staticRenderFns } from "./ScreenShot.vue?vue&type=template&id=312d8bb9"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports